import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { activateEditMode } from 'src/app/root-store/jobseeker-store/jobseeker-subscription/actions';

@Component({
    selector: 'app-jobseeker-unsubscriber-complete',
    templateUrl: './redesign/jobseeker-unsubscribe-complete.component.html',
    styleUrls: ['./redesign/jobseeker-unsubscribe-complete.component.scss'],
    standalone: false
})
export class JobseekerUnsubscribeCompleteComponent {
  private store = inject(Store);
  private router = inject(Router);

  onActivateEditMode() {
    this.store.dispatch(activateEditMode());
    this.router.navigate(['/jobseeker/subscription/edit']);
  }
}
